<template>
  <div>
    <template v-if="isDraft">
      <el-tag :size="size" type="warning" class="font-medium mt-0.5" :effect="statusEffect">Draft</el-tag>
    </template>
    <template v-else>
      <el-tag :size="size" :type="statusType" class="font-medium mt-0.5" :effect="statusEffect">{{ statusText }}</el-tag>
    </template>
  </div>
</template>
<script>
import Vue from 'vue'
import { Tag } from 'element-ui'
Vue.use(Tag)

export default {
  name: 'CampaignStatus',
  props: {
    status: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: 'small', // medium, small, mini
    },
    type: {
      type: String,
      default: null,
    },
    effect: {
      type: String,
      default: null,
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusMap: {
        0: { type: '', text: 'New', effect: 'light' },
        2: { type: 'info', text: 'In Review', effect: 'light' },
        1: { type: 'danger', text: 'Revision Requested', effect: 'light' },
        3: { type: 'success', text: 'Approved', effect: 'light' },
        4: { type: 'warning', text: 'In Progress', effect: 'light' },
        5: { type: 'warning', text: 'Ready to Launch', effect: 'dark' },
        6: { type: 'success', text: 'Active', effect: 'dark' },
        7: { type: 'info', text: 'Completed', effect: 'dark' },
      },
    }
  },
  computed: {
    statusType() {
      return this.type ? this.type : this.statusMap[this.status].type
    },
    statusText() {
      return this.statusMap[this.status].text
    },
    statusEffect() {
      return this.effect ? this.effect : this.statusMap[this.status].effect
    },
  },
}
</script>
